import { McpPolicyIntentGroup } from './policyTypes';

export const MCP_POLICY_STATUS = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error',
} as const;

export type McpPolicyStatus =
  (typeof MCP_POLICY_STATUS)[keyof typeof MCP_POLICY_STATUS];

/** Why policy check failed; only set when `mcpPolicyStatus === 'error'`. */
export const MCP_POLICY_ERROR_KIND = {
  policyFetchFailed: 'policyFetchFailed',
  redirectNotAllowed: 'redirectNotAllowed',
  missingRedirect: 'missingRedirect',
  workspaceAccessRevoked: 'workspaceAccessRevoked',
  unexpected: 'unexpected',
} as const;

export type McpPolicyErrorKind =
  (typeof MCP_POLICY_ERROR_KIND)[keyof typeof MCP_POLICY_ERROR_KIND];

export type PolicyState =
  | { status: 'idle' | 'loading' }
  | {
      status: 'error';
      errorMessage: string | null;
      errorKind: McpPolicyErrorKind;
      errorWorkspaceName?: string | null;
    }
  | {
      status: 'success';
      byIntent: McpPolicyIntentGroup[];
      crossOrgScopesRemoved: boolean;
    };

type PolicyAction =
  | { type: 'RESET' }
  | { type: 'LOADING' }
  | {
      type: 'SUCCESS';
      byIntent: McpPolicyIntentGroup[];
      crossOrgScopesRemoved: boolean;
    }
  | {
      type: 'ERROR';
      errorMessage: string | null;
      errorKind: McpPolicyErrorKind;
      errorWorkspaceName?: string | null;
    };

export function policyReducer(
  _: PolicyState,
  action: PolicyAction,
): PolicyState {
  switch (action.type) {
    case 'RESET':
      return { status: 'idle' };
    case 'LOADING':
      return { status: 'loading' };
    case 'SUCCESS':
      return {
        status: 'success',
        byIntent: action.byIntent,
        crossOrgScopesRemoved: action.crossOrgScopesRemoved,
      };
    case 'ERROR':
      return {
        status: 'error',
        errorMessage: action.errorMessage,
        errorKind: action.errorKind,
        errorWorkspaceName: action.errorWorkspaceName ?? null,
      };
  }
}
